import { ComponentMachine } from './types';

export const getComponent = (machineState: ComponentMachine) => {
  return machineState.context;
};

export const componentSelectors = {
  getComponent,
};
